export default "__VITE_ASSET__CvClN0F0__"